var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "white",
    stroke: "#F9FAFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.275 28.7622C23.8272 28.7622 27.9566 22.5043 27.9566 17.0807C27.9566 16.9019 27.9566 16.7231 27.9481 16.5528C28.7484 15.9738 29.4466 15.2501 30 14.4242C29.2678 14.7478 28.4759 14.9691 27.6415 15.0713C28.493 14.5605 29.1401 13.7601 29.4466 12.798C28.6547 13.2663 27.7778 13.6069 26.8412 13.7942C26.092 12.9938 25.0277 12.5 23.8442 12.5C21.5794 12.5 19.7403 14.3391 19.7403 16.6039C19.7403 16.9274 19.7744 17.2424 19.851 17.5404C16.4368 17.3702 13.4142 15.7354 11.3878 13.2493C11.0387 13.8538 10.8344 14.5605 10.8344 15.3097C10.8344 16.7316 11.5581 17.9917 12.665 18.7239C11.9923 18.7069 11.3623 18.5196 10.8089 18.2131C10.8089 18.2301 10.8089 18.2471 10.8089 18.2642C10.8089 20.2565 12.2222 21.9083 14.1039 22.2914C13.7633 22.3851 13.3972 22.4361 13.0226 22.4361C12.7586 22.4361 12.5032 22.4106 12.2478 22.3595C12.7671 23.9943 14.2827 25.1777 16.0792 25.2118C14.6743 26.3101 12.9034 26.9657 10.9791 26.9657C10.6471 26.9657 10.3235 26.9487 10 26.9061C11.7965 28.0811 13.9591 28.7622 16.275 28.7622Z",
    fill: "#FB4646"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/twitterLogo.c5104c9d.svg";
export { ForwardRef as ReactComponent };